/* Loupe – FAQ topic tabs. One group visible at a time; arrow keys, Home and End move between tabs.
   Without JS every group stays visible. In the theme editor, selecting a block shows its group. */
(() => {
  if (customElements.get('faq-tabs')) return;

  class FaqTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-fq-tab]')];
      this.panels = [...this.querySelectorAll('[data-fq-panel]')].filter((p) => p.dataset.fqPanel !== '0');
      if (this.tabs.length < 2) return;
      const current = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true') || this.tabs[0];
      this.select(current, false);
      this.classList.add('is-ready');

      this.onClick = (e) => {
        const tab = e.target.closest('[data-fq-tab]');
        if (tab && this.contains(tab)) this.select(tab, false);
      };
      this.onKey = (e) => {
        const tab = e.target.closest('[data-fq-tab]');
        if (!tab) return;
        const i = this.tabs.indexOf(tab);
        const rtl = getComputedStyle(this).direction === 'rtl';
        let n = -1;
        if (e.key === 'ArrowRight') n = i + (rtl ? -1 : 1);
        else if (e.key === 'ArrowLeft') n = i + (rtl ? 1 : -1);
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = this.tabs.length - 1;
        else return;
        e.preventDefault();
        n = (n + this.tabs.length) % this.tabs.length;
        this.select(this.tabs[n], true);
      };
      this.onBlockSelect = (e) => {
        if (!this.contains(e.target)) return;
        const panel = e.target.closest('[data-fq-panel]');
        if (!panel || panel.dataset.fqPanel === '0') return;
        const tab = this.tabs.find((t) => t.dataset.fqTab === panel.dataset.fqPanel);
        if (tab) this.select(tab, false);
        if (e.target.tagName === 'DETAILS') e.target.open = true;
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    select(tab, focus) {
      const id = tab.dataset.fqTab;
      this.tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((p) => { p.hidden = p.dataset.fqPanel !== id; });
      if (focus) tab.focus();
    }
  }

  customElements.define('faq-tabs', FaqTabs);
})();
